module.exports = __webpack_public_path__ + "static/media/zeya_walk_03.30a8ebd5.svg";